import React from "react";

export default function DifferenceSection() {
	return (
		<>
			<div className="difference-section-container px-2">
				<div className="difference-section">
					{/*<div className="text-center pb-5">*/}
					{/*	<h1 className="fw-bolder text-primary">The Meera Difference</h1>*/}
					{/*</div>*/}
					<div className="row align-items-center justify-content-center">

						<div className="col-md-6 text-center mb-4 mb-md-0 order-1 order-md-1" data-aos="fade-right">
							<img
								src="/assets/images/aboutus/craftingImage_aboutus.png"
								alt="Crafting jewellery"
								className="img-fluid difference-image"
							/>
						</div>

						<div className="col-md-6 text-center mb-4 mb-md-0 order-2 order-md-2 about-difference" data-aos="fade-left">
							<h2 className="section-subtitle text-primary">
								Not All jewellery is <br /> Manufactured the same
							</h2>
							<p className="description text-primary mb-4">
								Making jewellery is a craft we love. And we understand how important
								and special jewellery purchases are for consumers. With cutting edge
								technology and seasoned artisans, we put our minds and souls into
								making breathtaking pieces of jewellery.
							</p>
							<div className="text-center">
								<a
									href="https://docs.google.com/forms/d/e/1FAIpQLSc-vfXH4G2yhACdb1gjHPwLDATu3Z5VkjhxsGIRt8ZLx439WQ/viewform"
									target="_blank"
									rel="noopener noreferrer"
								>
									<button className="aboutusBtns bg-primary">Book Factory Visit</button>
								</a>
								
							</div>
						</div>

					</div>
				</div>
			</div>
		</>
	);
}